import {FC, useCallback} from "react";
import Button, {ButtonProps} from "@memaro/components/Button.tsx";
import East from "@mui/icons-material/East";

type MoveRightButtonProps = ButtonProps & {
    index: number,
    onClick: (index: number) => void
}

const MoveRightButton: FC<MoveRightButtonProps> = ({index, onClick, ...rest}) => {
    const handleClick = useCallback(() => onClick(index), [onClick, index])

    return (
        <Button onClick={handleClick} {...rest}>
            <span>Foto naar achter plaatsen</span>
            <East />
        </Button>
    )
}


export default MoveRightButton
